function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, makeObservable, observable, runInAction, toJS } from "mobx";
import filterOutUndefined from "../../Core/filterOutUndefined";
import flatten from "../../Core/flatten";
import isDefined from "../../Core/isDefined";
import TerriaError from "../../Core/TerriaError";
import { getObjectId } from "../../Traits/ArrayNestedStrataMap";
import addModelStrataView from "./addModelStrataView";
import createStratumInstance from "./createStratumInstance";
import { isLoadableStratum } from "./LoadableStratum";
import { BaseModel } from "./Model";
import StratumOrder from "./StratumOrder";
export default function CreateModel(Traits) {
  var _class, _descriptor, _Model;
  let Model = (_class = (_Model = class Model extends BaseModel {
    constructor() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const [id, terria, sourceReference, strata] = args;
      super(id, terria, sourceReference);
      _defineProperty(this, "traits", Traits.traits);
      _defineProperty(this, "TraitsClass", Traits);
      _defineProperty(this, "strata", void 0);
      /**
       * Gets the uniqueIds of models that are known to contain this one.
       * This is important because strata sometimes flow from container to
       * container, so the properties of this model may not be complete
       * if the container isn't loaded yet. It's also important for locating
       * this model in a hierarchical catalog.
       */
      _initializerDefineProperty(this, "knownContainerUniqueIds", _descriptor, this);
      this.strata = strata || observable.map();
      makeObservable(this);
    }
    dispose() {}
    getOrCreateStratum(id) {
      let result = this.strata.get(id);
      if (!result) {
        const newStratum = createStratumInstance(Traits);
        runInAction(() => {
          this.strata.set(id, newStratum);
        });
        result = newStratum;
      }
      return result;
    }
    duplicateModel(newId, sourceReference) {
      let newModel;
      try {
        newModel = new this.constructor(newId, this.terria, sourceReference);
      } catch (_e) {
        throw TerriaError.from("Failed to create model `\"".concat(newId, "\"`"));
      }
      this.strata.forEach((stratum, stratumId) => {
        try {
          const newStratum = isLoadableStratum(stratum) ? stratum.duplicateLoadableStratum(newModel) : createStratumInstance(Traits, toJS(stratum));
          newModel.strata.set(stratumId, newStratum);
        } catch (e) {
          throw TerriaError.from(e, {
            message: "Failed to duplicate stratum `".concat(stratumId, "` for model `").concat(newId, "`."),
            importance: -1
          });
        }
      });
      return newModel;
    }
    get strataTopToBottom() {
      return StratumOrder.sortTopToBottom(this.strata);
    }
    get strataBottomToTop() {
      return StratumOrder.sortBottomToTop(this.strata);
    }
    setTrait(stratumId, trait, value) {
      this.getOrCreateStratum(stratumId)[trait] = value;
    }
    getTrait(stratumId, trait) {
      return this.getOrCreateStratum(stratumId)[trait];
    }
    addObject(stratumId, traitId, objectId) {
      const trait = this.traits[traitId];
      const nestedTraitsClass = trait.type;
      const newStratum = createStratumInstance(nestedTraitsClass);
      const stratum = this.getOrCreateStratum(stratumId);
      let array = stratum[traitId];
      if (array === undefined) {
        stratum[traitId] = [];
        array = stratum[traitId];
      }

      // If objectID is provided, set idProperty and then return new object
      if (isDefined(objectId)) {
        newStratum[trait.idProperty] = objectId;
        array.push(newStratum);
        const models = this[traitId];
        return models.find((o, i) => getObjectId(trait.idProperty, o, i) === objectId);
      }
      // If no objectID is provided, we create a new object the end of the array (across all strata)
      // This method `isRemoval` and `idProperty="index"` into account.
      else {
        let maxIndex = -1;
        this.strata.forEach(s => {
          var _s$traitId;
          return (_s$traitId = s[traitId]) === null || _s$traitId === void 0 ? void 0 : _s$traitId.forEach((_e, idx) => maxIndex = idx > maxIndex ? idx : maxIndex);
        });

        // Make array in this stratum the same length as largest array across all strata
        for (let i = array.length; i <= maxIndex; i++) {
          array[i] = createStratumInstance(nestedTraitsClass);
        }

        // Add new object at the end of the array
        array[maxIndex + 1] = newStratum;

        // Return newly created model
        const models = this[traitId];
        return models[models.length - 1];
      }
    }

    /** Return full list of knownContainerUniqueIds.
     * This will recursively traverse tree of knownContainerUniqueIds models to return full list of dependencies
     */
    get completeKnownContainerUniqueIds() {
      const findContainers = model => [...model.knownContainerUniqueIds, ...flatten(filterOutUndefined(model.knownContainerUniqueIds.map(parentId => {
        const parent = this.terria.getModelById(BaseModel, parentId);
        if (parent) {
          return findContainers(parent);
        }
      })))];
      return findContainers(this).reverse();
    }
  }, _defineProperty(_Model, "TraitsClass", Traits), _defineProperty(_Model, "traits", Traits.traits), _Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "knownContainerUniqueIds", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "strataTopToBottom", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "strataTopToBottom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "strataBottomToTop", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "strataBottomToTop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTrait", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTrait"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completeKnownContainerUniqueIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "completeKnownContainerUniqueIds"), _class.prototype), _class);
  addModelStrataView(Model, Traits);
  return Model;
}